// need to use the * as x syntax as this is something completely different when run downstream
import * as icons from '../getIconAtlas';
export var getIconSet = function () {
    // In non-webpack builds this will be a function that returns the default set
    if (icons.default && typeof icons.default === 'function') {
        var realIcons = icons.default();
        return realIcons;
    }
    // Not sure if this can even happen but it can't hurt
    if (typeof icons === 'function') {
        var realIcons = icons();
        return realIcons;
    }
    // no idea
    if (icons.default) {
        return icons.default;
    }
    return icons;
};
export default getIconSet;
//# sourceMappingURL=index.js.map